export type NasaTlxDimensionId =
  | "mentalDemand"
  | "physicalDemand"
  | "temporalDemand"
  | "performance"
  | "effort"
  | "frustration";

export type NasaTlxItem = {
  id: NasaTlxDimensionId;
  title: string;
  question: string;
  labelLow: string;
  labelHigh: string;
};

/** Hart & Staveland NASA-TLX dimensions (1 = low anchor, 7 = high anchor per scale). */
export const NASA_TLX_ITEMS: NasaTlxItem[] = [
  {
    id: "mentalDemand",
    title: "Mental Demand",
    question: "How mentally demanding was the documentation process?",
    labelLow: "Very Low",
    labelHigh: "Very High",
  },
  {
    id: "physicalDemand",
    title: "Physical Demand",
    question: "How physically demanding was the documentation process?",
    labelLow: "Very Low",
    labelHigh: "Very High",
  },
  {
    id: "temporalDemand",
    title: "Temporal Demand",
    question:
      "How hurried or rushed was the pace of the documentation process?",
    labelLow: "Very Low",
    labelHigh: "Very High",
  },
  {
    id: "performance",
    title: "Performance",
    question:
      "How successful were you in accomplishing the documentation process?",
    labelLow: "Perfect",
    labelHigh: "Failure",
  },
  {
    id: "effort",
    title: "Effort",
    question:
      "How hard did you have to work to accomplish the documentation process?",
    labelLow: "Very Low",
    labelHigh: "Very High",
  },
  {
    id: "frustration",
    title: "Frustration",
    question:
      "How insecure, discouraged, irritated, stressed, and annoyed were you during the documentation process?",
    labelLow: "Very Low",
    labelHigh: "Very High",
  },
];

/** Two questions per screen (indices into NASA_TLX_ITEMS). */
export const NASA_TLX_PAGE_PAIRS: [number, number][] = [
  [0, 1],
  [2, 3],
  [4, 5],
];

export const emptyNasaTlxScores = (): Record<
  NasaTlxDimensionId,
  number | null
> =>
  ({
    mentalDemand: null,
    physicalDemand: null,
    temporalDemand: null,
    performance: null,
    effort: null,
    frustration: null,
  } as Record<NasaTlxDimensionId, number | null>);
